import ELogo2 from "../assets/ELogo2.png";

const previewTiles = [
  ["Demo Class", "Integrated learning", "from-emerald-500 to-teal-600"],
  ["1st Year Maths", "Numbers & patterns", "from-sky-500 to-cyan-600"],
  ["2nd Year Science", "Energy", "from-violet-500 to-purple-600"],
  ["3rd Year Maths", "Problem solving", "from-indigo-500 to-blue-600"],
  ["TY Physics", "Practical work", "from-fuchsia-500 to-pink-600"],
  ["5th Year Physics", "Leaving Certificate", "from-amber-400 to-orange-500"],
] as const;

/** A deployment-owned, token-free visual of the fictional workspace. */
export default function DemoDashboardPreview() {
  return (
    <figure className="overflow-hidden rounded-[28px] border border-white/80 bg-white shadow-[0_28px_70px_rgba(49,46,129,0.22)]">
      <div className="flex items-center gap-2 border-b border-slate-200 bg-slate-50 px-4 py-3">
        <span className="h-2.5 w-2.5 rounded-full bg-rose-400" />
        <span className="h-2.5 w-2.5 rounded-full bg-amber-400" />
        <span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
        <div className="ml-2 h-6 flex-1 rounded-full bg-white" />
      </div>
      <div className="bg-[radial-gradient(circle_at_top_right,rgba(196,181,253,0.65),transparent_34%),linear-gradient(135deg,#ecfdf5,#eff6ff_55%,#faf5ff)] p-4 sm:p-5">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <img src={ELogo2} alt="" className="h-8 w-8 object-contain" />
            <div>
              <div className="text-sm font-black text-slate-900">Elume</div>
              <div className="text-[10px] font-semibold text-slate-500">Learn, Grow, Succeed</div>
            </div>
          </div>
          <div className="rounded-xl bg-white/90 px-3 py-1.5 text-xs font-bold text-slate-700 shadow-sm">Welcome, Demo User</div>
        </div>
        <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3">
          {previewTiles.map(([name, subject, gradient], index) => (
            <div key={name} className={`relative min-h-24 rounded-2xl bg-gradient-to-br ${gradient} p-3 text-white shadow-[0_5px_0_rgba(15,23,42,0.16)] ${index === 0 ? "ring-4 ring-violet-300/80" : ""}`}>
              {index === 0 && <span className="absolute -top-2 left-3 rounded-full bg-violet-700 px-2 py-0.5 text-[9px] font-black tracking-wide text-white">START HERE</span>}
              <div className="pt-1 text-sm font-black leading-tight">{name}</div>
              <div className="mt-1 text-[10px] font-semibold text-white/85">{subject}</div>
              <div className="mt-4 inline-flex rounded-full bg-white/20 px-2 py-1 text-[9px] font-bold">Open class</div>
            </div>
          ))}
          <div className="hidden min-h-24 rounded-2xl border-2 border-dashed border-slate-300 bg-white/70 p-3 text-xs font-bold text-slate-500 sm:block">Your next class<br /><span className="text-[10px] font-medium">is ready when you are</span></div>
        </div>
      </div>
      <figcaption className="sr-only">Preview of the fictional Elume dashboard included in the public demo.</figcaption>
    </figure>
  );
}
